import axios from '../configV2';
const resource = '/text_replacement';

export default {
    async getTextReplacements (per_page, page, search) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
        const params = new URLSearchParams();
        if (per_page)  params.append('per_page', per_page);
        if (page)     params.append('page', page);
        if (search)     params.append('search', search);
        return axios.get(`${resource}?${params.toString()}`);
    },

    async createTextReplacement (data) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
        return axios.post(resource, data).catch( (error) => { return error.response.data } );
    },

    async updateTextReplacement (id, data) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
        return axios.patch(`${resource}/${id}` , data).catch( (error) => { return error.response.data } );
    },

    async deleteTextReplacement (id) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth_token')}`;
        return axios.delete(`${resource}/${id}`).catch( (error) => { return error.response.data } );
    }

}